import { loadingGif } from '@resources';
import TypeUtils from '@utils/typeutils';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import muiThemeable from 'material-ui/styles/muiThemeable';
import { FormattedMessage, injectIntl } from 'react-intl';
import './Misc.css';

let SubTitle = props => (
  <h3
    className="SubTitle"
    style={{ color: props.muiTheme.palette.accent3Color }}
  >
    {props.children}
  </h3>
);

let GeneralError = props => (
  <div
    style={{
      textAlign: 'left',
      position: 'relative',
      bottom: '2px',
      fontSize: '12px',
      color: 'rgb(244, 67, 54)',
      transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    }}
  >
    <span>{props.message}</span>
  </div>
);

// TODO: Replace all usages of this component with CustomMaterialUI/DynamicSelectField and remove this one.
// This component is just a Material-UI SelectField whose items are dynamically built from props
const DynamicSelector = ({ items, autoFocus, onChange, ...selectProps }) => {
  let itemIndex = 0;
  let arrSelectItems = null;
  let refFnWrapperDivElem;
  let wrapperDivElem = null;

  if (items) {
    arrSelectItems = items.map(item => (
      <MenuItem
        key={itemIndex++}
        className="muiMenuItem"
        value={item.value}
        primaryText={item.text}
      />
    ));
  }

  // Auxiliary function to focus on the dynamic selector
  const focusOnSelector = () => {
    if (wrapperDivElem && wrapperDivElem.getElementsByTagName) {
      const arrChildrenButtons = wrapperDivElem.getElementsByTagName('button');

      if (
        arrChildrenButtons &&
        arrChildrenButtons.length &&
        arrChildrenButtons.length > 0
      ) {
        arrChildrenButtons[0].focus();
      }
    }
  };

  // When set to true, the autoFocus prop causes the select field to be focused immediately when rendered
  if (autoFocus) {
    refFnWrapperDivElem = e => {
      wrapperDivElem = e;
      focusOnSelector();
    };
  }

  // Moreover when autoFocus is set to true, let the focus set on the select field anytime its value gets changed
  const onChangeWrapper = (e, key, payload) => {
    if (onChange && TypeUtils.isFunction(onChange)) {
      onChange(e, key, payload);
    }

    if (autoFocus) {
      focusOnSelector();
    }
  };

  return (
    <div ref={refFnWrapperDivElem}>
      <SelectField onChange={onChangeWrapper} {...selectProps}>
        {arrSelectItems}
      </SelectField>
    </div>
  );
};

const LoadingBox = props => (
  <div className="LoadingBox">
    <img src={loadingGif} alt="" />
  </div>
);

let ErrorAlertBox = props => {
  const actions = [<FlatButton label="OK" primary onClick={null} />];

  return (
    <Dialog title="Error" open={false} actions={actions} modal>
      <span>
        <FormattedMessage
          id="LcAccountSetup.stepLabelCreateAccount"
          default="ERROR!"
        />
      </span>
    </Dialog>
  );
};

let NoticeBox = ({
  muiTheme = {},
  open = false,
  title = 'Notice',
  messageId = null,
  details = null,
  width = '25%',
  onOk = () => {},
}) => {
  const actions = [<FlatButton label="OK" primary onClick={onOk} />];

  return (
    <Dialog
      title={title}
      open={open}
      actions={actions}
      modal
      contentStyle={{ width }}
    >
      <div style={{ position: 'relative', paddingLeft: '2.5em' }}>
        <div style={{ position: 'absolute', left: '0', top: '0' }}>
          <FontIcon className="material-icons">error</FontIcon>
        </div>
        <div>
          {messageId && <FormattedMessage id={messageId} default="ERROR!" />}
        </div>
        <div>{details}</div>
      </div>
    </Dialog>
  );
};

SubTitle = muiThemeable()(SubTitle);
GeneralError = muiThemeable()(GeneralError);
ErrorAlertBox = muiThemeable()(injectIntl(ErrorAlertBox));
NoticeBox = muiThemeable()(injectIntl(NoticeBox));

export {
  SubTitle,
  GeneralError,
  ErrorAlertBox,
  DynamicSelector,
  LoadingBox,
  NoticeBox,
};
